module.exports = __webpack_public_path__ + "img/Refraichir_Bouton.d4b37ee5.png";